'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Script from 'next/script'

export default function GoogleAnalytics({ gaId }) {
    const pathname = usePathname()

    useEffect(() => {
        if (!window.gtag) return
        const fullPath = `${pathname}${window.location.search || ''}`
        window.gtag('config', gaId, { page_path: fullPath })
    }, [gaId, pathname])

    return (
        <>
            <Script
                strategy="lazyOnload"
                src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
            />
            <Script id="gtag-init" strategy="lazyOnload">
                {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}', { page_path: window.location.pathname });
        `}
            </Script>
        </>
    )
}
